import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:23
* @route '/teacher/students'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/students',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:23
* @route '/teacher/students'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:23
* @route '/teacher/students'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::index
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:23
* @route '/teacher/students'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::list
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:50
* @route '/teacher/students/list'
*/
export const list = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: list.url(options),
    method: 'get',
})

list.definition = {
    methods: ["get","head"],
    url: '/teacher/students/list',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::list
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:50
* @route '/teacher/students/list'
*/
list.url = (options?: RouteQueryOptions) => {
    return list.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::list
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:50
* @route '/teacher/students/list'
*/
list.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: list.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::list
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:50
* @route '/teacher/students/list'
*/
list.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: list.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:69
* @route '/teacher/students/{student}'
*/
export const show = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/teacher/students/{student}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:69
* @route '/teacher/students/{student}'
*/
show.url = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { student: args }
    }

    if (Array.isArray(args)) {
        args = {
            student: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        student: args.student,
    }

    return show.definition.url
            .replace('{student}', parsedArgs.student.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:69
* @route '/teacher/students/{student}'
*/
show.get = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherStudentController::show
* @see app/Http/Controllers/Teacher/TeacherStudentController.php:69
* @route '/teacher/students/{student}'
*/
show.head = (args: { student: string | number } | [student: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const students = {
    index: Object.assign(index, index),
    list: Object.assign(list, list),
    show: Object.assign(show, show),
}

export default students